export default __webpack_public_path__ + "static/media/demo-8.4fd6a771.png";